import { FC, createElement } from 'react'
import { Box, Card, SxProps, Typography } from '@mui/material'

type ItemProps = {
  title: string | React.ReactNode
  data: string | React.ReactNode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: FC<any>
  sx?: SxProps
  testId?: string
}

const ItemCard = ({ title, data, icon, testId, sx }: ItemProps) => (
  <Card
    data-testid={testId}
    sx={{
      position: 'relative',
      overflow: 'hidden',
      padding: '25px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .icon': {
        color: 'secondary.main'
      },
      '&:before': {
        position: 'absolute',
        top: '50%',
        left: 0,
        display: 'block',
        content: `''`,
        height: '200%',
        aspectRatio: '1',
        transform: 'translate(-30%, -60%)',
        borderRadius: '50%',
        backgroundColor: 'secondary.main',
        opacity: 0.15
      },
      ...sx
    }}
  >
    <Box width="3em" className="icon" sx={{ width: '3em', mr: 2 }}>
      {createElement(icon, { fontSize: 'large' })}
    </Box>
    <Box textAlign="right">
      <Box color="textSecondary">{title}</Box>
      <Typography sx={{ fontSize: '1.5rem' }}>{data}</Typography>
    </Box>
  </Card>
)

export default ItemCard
